(function($){

	var lastScrollTop = 0;

	$(window).on('scroll',function(){
		var $site_header = $('#site-header');

		if($site_header.length && $(window).scrollTop() >= 20 && !$site_header.hasClass('scroll')) {
			$site_header.addClass('scroll');
		}

		if($site_header.length && $(window).scrollTop() < 20) {
			$site_header.removeClass('scroll');
		}
	});
	
})(jQuery);